const _entities = [
  {
    id: 1,
    internalId: 3,
    name: 'De Wilde Eend',
    slogan: 'Seascouts',
    fragment: 'de-wilde-eend',
    startingAge: 7,
    whenShort: ['za', 'zo'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 17u15'
      },
      {
        day: 'Zondag',
        timeSpan: '10u00 - 17u15'
      }
    ],
    addresses: [
      {
        id: 1,
        address: 'Veerstraat 82, 9031 Drongen',
        addressLine: 'Veerstraat 82',
        city: 'Drongen',
        postcode: '9031'
      },
      {
        id: 2,
        address: 'Voorhavenlaan, 9000 Gent',
        addressLine: 'Voorhavenlaan/Oslostraat (+12)',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    contact: 'info@dewildeeend.be',
    website: 'http://dewildeeend.be',
    district: 'Drongen',
    money: '€120 - €130'
  },
  {
    id: 2,
    internalId: 24,
    name: 'Tom Wilson',
    fragment: 'tom-wilson',
    slogan: 'Tweetalig',
    startingAge: 7,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 17u15'
      }
    ],
    addresses: [
      {
        id: 1,
        address: 'Goedingenstraat 8, 9000 Gent',
        addressLine: 'Goedingenstraat 8',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    contact: 'cu@tomwilson.be',
    website: 'http://www.tomwilson.be/fr',
    district: 'Afsnee',
    money: '€105'
  },
  {
    id: 3,
    internalId: 120,
    name: 'De Zwaluw',
    fragment: 'de-zwaluw',
    slogan: 'Spel en techniek',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 17u30'
      }
    ],
    website: 'http://dezwaluw.org/',
    addresses: [
      {
        id: 1,
        address: 'Begijnhofdries 42, 9000 Gent',
        addressLine: 'Begijnhofdries 42',
        city: 'Gent',
        postcode: '9000'
      },
      {
        id: 2,
        address: 'Viaductstraat, 9032 Wondelgem',
        addressLine: 'Viaductstraat',
        city: 'Wondelgem',
        postcode: '9032'
      }
    ],
    district: 'Wondelgem',
    contact: 'el@dezwaluw.org',
    money: '€50'
  },
  {
    id: 4,
    internalId: 151,
    name: 'De Koala\'s',
    fragment: 'de-koala-s',
    slogan: 'Vree wijs',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00-17u30 (winter) | 18u00 (zomer)'
      }
    ],
    website: 'https://koalas.be/',
    addresses: [
      {
        id: 1,
        address: 'Zandloperstraat 81, 9030 Mariakerke',
        addressLine: 'Zandloperstraat 81',
        city: 'Mariakerke',
        postcode: '9030'
      }
    ],
    district: 'Mariakerke',
    contact: 'koalas.info@gmail.com',
    money: '€71'
  },
  {
    id: 5,
    internalId: 191,
    name: 'De Reiger',
    fragment: 'de-reiger',
    slogan: 'Dynamisch',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u30 - 18u00'
      }
    ],
    website: 'http://fosdereiger.be/',
    addresses: [
      {
        id: 1,
        address: 'Sneppenbrugstraat 6, 9000 Gent',
        addressLine: 'Sneppenbrugstraat 6',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    district: 'Gent-Sint-Pieters',
    contact: 'info@fosdereiger.be',
    money: '€70'
  },
  {
    id: 6,
    internalId: 192,
    name: 'De Wouw',
    fragment: 'de-wouw',
    slogan: 'Wauw',
    startingAge: 5,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 17u00'
      }
    ],
    website: 'https://wouw.org/',
    addresses: [
      {
        id: 1,
        address: 'Jules Van Biesbroeckstraat 2a, 9050 Gentbrugge',
        addressLine: 'Jules Van Biesbroeckstraat 2a',
        city: 'Gentbrugge',
        postcode: '9050'
      }
    ],
    district: 'Gentbrugge',
    contact: 'info@wouw.org',
    money: '€60'
  },
  {
    id: 7,
    internalId: 204,
    name: 'De Tortels',
    fragment: 'de-tortels',
    slogan: 'Discipline',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00-17u30 (winter) | 18u00 (zomer)'
      }
    ],
    website: 'http://tortels.be/',
    addresses: [
      {
        id: 1,
        address: 'Botestraat 98B001, 9032 Wondelgem',
        addressLine: 'Botestraat 98B001',
        city: 'Wondelgem',
        postcode: '9032'
      }
    ],
    district: 'Wondelgem',
    contact: 'eenheidsleiding@tortels.be',
    money: '€65'
  },
  {
    id: 8,
    internalId: 206,
    name: 'De Flamingo\'s',
    fragment: 'de-flamingo-s',
    slogan: 'Gezelligheid',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00-17u00 (winter) | 18u00 (zomer)'
      }
    ],
    website: 'http://deflamingos.be/',
    addresses: [
      {
        id: 1,
        address: 'Land van waaslaan 162, 9040 Sint-Amandsberg',
        addressLine: 'Land van waaslaan 162',
        city: 'Sint-Amandsberg',
        postcode: '9040'
      }
    ],
    district: 'Sint-Amandsberg',
    contact: '206deflamingos@gmail.com',
    money: '€49'
  },
  {
    id: 9,
    internalId: 9,
    name: 'De Kariboes',
    fragment: 'kariboes',
    slogan: 'Diversiteit',
    startingAge: 7,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 17u30'
      }
    ],
    website: 'https://www.dekariboes.be',
    addresses: [
      {
        id: 1,
        address: 'Neermeerskaai 1A, 9000 Gent',
        addressLine: 'Neermeerskaai 1A',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    district: 'Centrum',
    contact: 'info@dekariboes.be',
    money: '€57'
  },
  {
    id: 10,
    internalId: 250,
    name: 'De Grizzly',
    fragment: 'de-grizzly',
    slogan: 'Vriendschap',
    startingAge: 6,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '13u30 - 17u30'
      }
    ],
    website: 'https://degrizzly.be/',
    addresses: [
      {
        id: 1,
        address: 'Roggestraat 19, 9000 Gent',
        addressLine: 'Roggestraat 19',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    district: 'Centrum',
    contact: 'info@degrizzly.be',
    money: '€60'
  },
  {
    id: 11,
    internalId: 281,
    name: 'De Zebra\'s',
    fragment: 'de-zebra-s',
    slogan: 'Verenigd',
    startingAge: 5,
    whenShort: ['za'],
    whenLong: [
      {
        day: 'Zaterdag',
        timeSpan: '14u00 - 18u00'
      }
    ],
    website: 'http://dezebras.be/',
    addresses: [
      {
        id: 1,
        address: 'Baudelohof 6, 9000 Gent',
        addressLine: 'Baudelohof 6',
        city: 'Gent',
        postcode: '9000'
      }
    ],
    district: 'Centrum',
    contact: 'eenheidsleiding@dezebras.be',
    money: '€50'
  }
];

export default {
  getEntities(cb) {
    setTimeout(() => cb(_entities), 1)
  }
}



// WEBPACK FOOTER //
// ./src/api/entities.js